var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOdogwuCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1018 10.8127C14.1018 10.8127 14.285 11.1853 15.0581 10.8127L14.2715 11.9999L13.5763 12.3306L14.1018 10.8127Z",
    fill: "#B56E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.57382 10.8127C5.57382 10.8127 5.39067 11.1853 4.61761 10.8127L5.40418 11.9999L6.09943 12.3306L5.57382 10.8127Z",
    fill: "#B56E00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3691 7.41878C15.3691 6.87853 14.931 6.44077 14.3907 6.44077C13.8508 6.44077 13.4124 6.87853 13.4124 7.41878C13.4124 7.75408 13.5821 8.04978 13.8395 8.22603C11.5361 14.374 10.5446 8.54481 10.3259 6.92719C10.739 6.74533 8.96889 6.74533 9.38199 6.92719C9.16326 8.54481 8.17173 14.374 5.86826 8.22603C6.1258 8.04978 6.29543 7.75407 6.29543 7.41878C6.29543 6.87853 5.8571 6.44077 5.3171 6.44077C4.77685 6.44077 4.33878 6.87853 4.33878 7.41878C4.33878 7.89505 4.68041 8.2912 5.13196 8.37804C5.16815 9.55416 5.33032 12.8426 6.00549 13.6241C6.00549 13.6241 6.63732 14.6668 9.85393 14.6456C13.0705 14.6668 13.7023 13.6241 13.7023 13.6241C14.3775 12.8426 14.5397 9.55415 14.5759 8.37804C15.0274 8.29119 15.3691 7.89504 15.3691 7.41878Z",
    fill: "#B56E00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4314 7.20887C12.0441 19.4306 10.5348 4.9834 10.5348 4.9834H9.85413H9.17347C9.17347 4.9834 7.66407 19.4306 3.27684 7.20887L2.25629 7.26126C2.25629 7.26126 2.34929 14.825 3.67612 16.3596C3.67612 16.3596 4.69007 18.0337 9.85413 17.9993C15.0181 18.0337 16.0321 16.3596 16.0321 16.3596C17.3589 14.825 17.4519 7.26126 17.4519 7.26126L16.4314 7.20887Z",
    fill: "url(#paint0_linear_235_10808)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8539 6.44098C10.1596 6.44098 10.4475 6.36647 10.7029 6.2371C10.5876 5.49175 10.5346 4.9834 10.5346 4.9834H9.8539H9.17324C9.17324 4.9834 9.1201 5.4918 9.00485 6.2371C9.26025 6.36647 9.5481 6.44098 9.8539 6.44098Z",
    fill: "#CA730F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8881 7.26167C16.8881 7.26167 16.795 14.8254 15.4682 16.36C15.4682 16.36 14.4888 17.9713 9.57214 17.9988C9.66545 17.9994 9.75759 18.0003 9.85378 17.9997C15.0178 18.0341 16.0317 16.36 16.0317 16.36C17.3586 14.8254 17.4515 7.26166 17.4515 7.26166H16.8881V7.26167Z",
    fill: "#CA730F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08085 11.8663C5.77701 12.5061 4.43494 10.4367 3.27637 7.20892L2.72318 7.23734C4.17172 11.2625 5.92224 12.8472 7.08085 11.8663Z",
    fill: "url(#paint1_linear_235_10808)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5891 11.8663C13.8929 12.5061 15.2351 10.4367 16.3936 7.20892L16.9468 7.23734C15.4982 11.2625 13.7477 12.8472 12.5891 11.8663Z",
    fill: "url(#paint2_linear_235_10808)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7381 3.88413C11.7381 4.92461 10.8941 5.76845 9.85378 5.76845C8.81341 5.76845 7.96945 4.92463 7.96945 3.88413C7.96945 2.84381 8.8134 1.99994 9.85378 1.99994C10.894 1.99994 11.7381 2.84381 11.7381 3.88413Z",
    fill: "url(#paint3_radial_235_10808)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0163 8.30694C16.3014 8.59792 16.6982 8.77899 17.1375 8.77899C17.2285 8.77899 17.3171 8.76956 17.4039 8.7547C17.4441 7.85992 17.4515 7.26119 17.4515 7.26119L16.431 7.2088C16.2898 7.60216 16.1516 7.96743 16.0163 8.30694Z",
    fill: "#CA730F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7079 6.39747C18.7079 7.26441 18.0045 7.96769 17.1376 7.96769C16.2706 7.96769 15.5673 7.26441 15.5673 6.39747C15.5673 5.53053 16.2707 4.82733 17.1376 4.82733C18.0045 4.82733 18.7079 5.53054 18.7079 6.39747Z",
    fill: "url(#paint4_radial_235_10808)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27684 7.2088L2.25629 7.26119C2.25629 7.26119 2.2635 7.8448 2.30225 8.72004C2.43653 8.75744 2.57746 8.77899 2.7236 8.77899C3.1082 8.77899 3.46012 8.64014 3.7332 8.41047C3.58463 8.04191 3.43263 7.64275 3.27684 7.2088Z",
    fill: "#CA730F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999939 6.39747C0.999939 7.26441 1.70323 7.96769 2.57016 7.96769C3.43711 7.96769 4.14043 7.26441 4.14043 6.39747C4.14043 5.53053 3.4371 4.82733 2.57016 4.82733C1.70324 4.82733 0.999939 5.53054 0.999939 6.39747Z",
    fill: "url(#paint5_radial_235_10808)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3998 15.2709C16.3998 15.2709 15.3253 17.045 9.85383 17.0088C4.38233 17.045 3.30782 15.2709 3.30782 15.2709C3.2013 15.1483 3.10685 14.9807 3.01501 14.7926C3.19157 15.4845 3.40743 16.0489 3.67582 16.3595C3.67582 16.3595 4.68977 18.0336 9.85383 17.9992C15.0178 18.0336 16.0318 16.3595 16.0318 16.3595C16.3002 16.0489 16.5161 15.4845 16.6926 14.7926C16.6007 14.9807 16.5063 15.1483 16.3998 15.2709Z",
    fill: "url(#paint6_linear_235_10808)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30782 15.5465C3.30782 15.5465 4.38233 17.3206 9.85383 17.2844C15.3253 17.3206 16.3998 15.5465 16.3998 15.5465C16.442 15.498 16.4819 15.4409 16.5209 15.3795C16.5818 15.1974 16.6392 15.0017 16.6926 14.7926C16.6007 14.9807 16.5063 15.1483 16.3998 15.2709C16.3998 15.2709 15.3253 17.045 9.85383 17.0088C4.38233 17.045 3.30782 15.2709 3.30782 15.2709C3.2013 15.1483 3.10685 14.9807 3.01501 14.7926C3.06841 15.0017 3.12579 15.1974 3.18666 15.3795C3.22572 15.4409 3.26564 15.498 3.30782 15.5465Z",
    fill: "#E8A033"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.36925 15.7885C3.36925 15.7885 4.43371 17.5459 9.85391 17.5101C15.2741 17.5459 16.3386 15.7885 16.3386 15.7885C16.3803 15.7404 16.4199 15.6838 16.4586 15.623C16.5188 15.4426 16.5757 15.2488 16.6286 15.0417C16.5376 15.228 16.444 15.3941 16.3386 15.5155C16.3386 15.5155 15.2742 17.273 9.85392 17.2371C4.43373 17.273 3.36926 15.5155 3.36926 15.5155C3.26373 15.3941 3.17017 15.228 3.07919 15.0417C3.13211 15.2488 3.18893 15.4426 3.24923 15.623C3.28793 15.6838 3.32745 15.7404 3.36925 15.7885Z",
    fill: "url(#paint7_linear_235_10808)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80695 13.6313L9.85417 11.8262L10.9014 13.6313L9.85417 15.4361L8.80695 13.6313Z",
    fill: "url(#paint8_radial_235_10808)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85425 16.0218V15.4362L10.9015 13.6314H11.2414L9.85425 16.0218Z",
    fill: "url(#paint9_linear_235_10808)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85403 16.0218V15.4362L8.80681 13.6314H8.46692L9.85403 16.0218Z",
    fill: "url(#paint10_linear_235_10808)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85394 11.2409L9.8542 11.8267L8.80672 13.6312H8.46683L9.85394 11.2409Z",
    fill: "url(#paint11_linear_235_10808)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.85425 11.2408L9.8545 11.8266L10.9015 13.6311H11.2416L9.85425 11.2408Z",
    fill: "url(#paint12_linear_235_10808)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48596 13.6314H6.19577L5.77695 12.9061L5.92217 12.6547L6.48596 13.6314Z",
    fill: "url(#paint13_linear_235_10808)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92217 14.6083L5.77695 14.3569L6.19577 13.6315H6.48596L5.92217 14.6083Z",
    fill: "url(#paint14_linear_235_10808)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23099 13.6315H4.52123L4.94006 12.9062L4.79479 12.6548L4.23099 13.6315Z",
    fill: "url(#paint15_linear_235_10808)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79449 12.6547L4.93976 12.9061H5.77686L5.92208 12.6547H4.79449Z",
    fill: "url(#paint16_linear_235_10808)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92208 14.6082L5.77686 14.3567H4.93976L4.79449 14.6082H5.92208Z",
    fill: "url(#paint17_linear_235_10808)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79476 14.6083L4.94003 14.3569L4.5212 13.6315H4.23096L4.79476 14.6083Z",
    fill: "url(#paint18_linear_235_10808)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77717 12.9061L6.19599 13.6314L5.77717 14.3568H4.94007L4.52124 13.6314L4.94007 12.9061H5.77717Z",
    fill: "url(#paint19_radial_235_10808)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4769 13.6314H15.1867L14.7679 12.9061L14.9131 12.6547L15.4769 13.6314Z",
    fill: "url(#paint20_linear_235_10808)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9131 14.6083L14.7679 14.3569L15.1867 13.6315H15.4769L14.9131 14.6083Z",
    fill: "url(#paint21_linear_235_10808)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2216 13.6315H13.5118L13.9307 12.9062L13.7854 12.6548L13.2216 13.6315Z",
    fill: "url(#paint22_linear_235_10808)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7856 12.6547L13.9309 12.9061H14.7679L14.9132 12.6547H13.7856Z",
    fill: "url(#paint23_linear_235_10808)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9132 14.6082L14.7679 14.3567H13.9309L13.7856 14.6082H14.9132Z",
    fill: "url(#paint24_linear_235_10808)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7852 14.6083L13.9305 14.3569L13.5116 13.6315H13.2214L13.7852 14.6083Z",
    fill: "url(#paint25_linear_235_10808)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9306 14.3564L13.5117 13.6314L13.9306 12.9061H14.7677L15.1865 13.6314L14.7677 14.3564H13.9306Z",
    fill: "url(#paint26_radial_235_10808)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_235_10808",
    x1: 2.25629,
    y1: 11.4916,
    x2: 17.4519,
    y2: 11.4916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1961,
    stopColor: "#C77000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3569,
    stopColor: "#EACE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F99B25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6549,
    stopColor: "#FADD1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7843,
    stopColor: "#FBC916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8902,
    stopColor: "#E0720A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_235_10808",
    x1: 6.62276,
    y1: 12.3891,
    x2: 2.94533,
    y2: 7.79229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0720A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1725,
    stopColor: "#FBC916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3804,
    stopColor: "#FADD1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8078,
    stopColor: "#EACE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C77000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_235_10808",
    x1: 13.092,
    y1: 12.3346,
    x2: 16.6212,
    y2: 7.91573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C77000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1922,
    stopColor: "#EACE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6196,
    stopColor: "#FADD1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8275,
    stopColor: "#FBC916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0720A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_235_10808",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.91307 2.93518) scale(2.72868)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "#FB9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B85900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_235_10808",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.1079 5.62644) scale(2.2104)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "#FB9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B85900"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_235_10808",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.57019 5.50781) scale(2.42225)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEE21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "#FB9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B85900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_235_10808",
    x1: 3.01502,
    y1: 16.3962,
    x2: 16.6926,
    y2: 16.3962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1961,
    stopColor: "#B36500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9AB48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7843,
    stopColor: "#FBD449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_235_10808",
    x1: 3.07918,
    y1: 16.2761,
    x2: 16.6286,
    y2: 16.2761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC60B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1725,
    stopColor: "#FBC916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3804,
    stopColor: "#FADD1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6588,
    stopColor: "#C77000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EACE1A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_235_10808",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.85417 13.6312) scale(1.47555)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3412,
    stopColor: "#D70000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7103,
    stopColor: "#CA0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_235_10808",
    x1: 9.82756,
    y1: 15.7579,
    x2: 11.0841,
    y2: 13.6313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C77000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA5100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_235_10808",
    x1: 9.88072,
    y1: 15.7579,
    x2: 8.62419,
    y2: 13.6313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_235_10808",
    x1: 9.88062,
    y1: 11.5047,
    x2: 8.62411,
    y2: 13.6312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_235_10808",
    x1: 9.82758,
    y1: 11.5047,
    x2: 11.0841,
    y2: 13.6313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C77000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_235_10808",
    x1: 6.52958,
    y1: 14.2381,
    x2: 5.84747,
    y2: 12.5773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_235_10808",
    x1: 5.88885,
    y1: 14.7387,
    x2: 6.31887,
    y2: 13.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C77000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA5100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_235_10808",
    x1: 4.26456,
    y1: 13.9618,
    x2: 4.91701,
    y2: 12.5531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C77000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_235_10808",
    x1: 6.4093,
    y1: 13.2455,
    x2: 4.60024,
    y2: 12.3855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_235_10808",
    x1: 4.93867,
    y1: 14.6009,
    x2: 5.7394,
    y2: 14.4082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C79F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC7000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_235_10808",
    x1: 4.8968,
    y1: 14.7678,
    x2: 4.40746,
    y2: 13.5518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C77000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA5100"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_235_10808",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.35862 13.6314) scale(0.783372)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5791C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3528,
    stopColor: "#0D6EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7344,
    stopColor: "#0B52A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2F47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_235_10808",
    x1: 15.2363,
    y1: 13.7697,
    x2: 14.9397,
    y2: 12.4648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_235_10808",
    x1: 14.976,
    y1: 13.9919,
    x2: 15.1978,
    y2: 14.1215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C77000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA5100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_235_10808",
    x1: 13.8118,
    y1: 13.9837,
    x2: 13.367,
    y2: 12.6343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C77000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_235_10808",
    x1: 14.5289,
    y1: 13.8005,
    x2: 14.3361,
    y2: 12.5698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_235_10808",
    x1: 14.3525,
    y1: 14.3429,
    x2: 14.3493,
    y2: 14.6144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C77000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_235_10808",
    x1: 13.7223,
    y1: 13.9919,
    x2: 13.5006,
    y2: 14.1215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C77000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_235_10808",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.3491 13.6313) scale(0.783307)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ABF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2794,
    stopColor: "#0ABB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5821,
    stopColor: "#09AE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8946,
    stopColor: "#089800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#078F00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdogwuCrown);
export default __webpack_public_path__ + "static/media/odogwu-crown.8a459138b5107d32d3bd5846ed066a1d.svg";
export { ForwardRef as ReactComponent };